import React, { Component } from 'react';
import { MasterLayout } from 'layout';
import { DatePicker } from 'components/tt-forms/common';
import { Link } from 'react-router';
import { ThanhTra } from 'api';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';
import { browserHistory } from 'react-router';

class CauHinhKHTT extends Component {
  constructor(props) {
    super(props);
    this.state = {
      denNgayKHTT: moment(),
      tuNgayKHTT: moment(),
      tuNgayTTDX: moment(),
      denNgayTTDX: moment(),
      choPhepChinhSuaKeHoachTuNgay: moment(),
      switch: false
    }
  }

  componentDidMount() {
    this.getInfoCauHinh();
  }

  getInfoCauHinh() {
    ThanhTra.actions.getCauHinhKeHoachThanhTra.request().then(res => {
      const { data } = res;
      if (!isEmpty(data)) {
        this.setState({
          switch: data.hienThiButtonThemMoi,
          tuNgayKHTT: moment(data.tuNgayKHTT, '').format('DD/MM/YYYY'),
          denNgayKHTT: moment(data.denNgayKHTT, '').format('DD/MM/YYYY'),
          tuNgayTTDX: moment(data.tuNgayCuocThanhTra, '').format('DD/MM/YYYY'),
          denNgayTTDX: moment(data.denNgayCuocThanhTra, '').format('DD/MM/YYYY'),
          choPhepChinhSuaKeHoachTuNgay: data.choPhepChinhSuaKeHoachTuNgay ? moment(data.choPhepChinhSuaKeHoachTuNgay, '').format('DD/MM/YYYY') : null,
        });
      }
    });
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  goBack() {
    browserHistory.goBack();
  }

  saveCauHinhThanhTra() {
    if (this.validateSubmitForm()) {
      const params = {
        hienThiButtonThemMoi: this.state.switch,
        tuNgayKHTT: moment(this.state.tuNgayKHTT, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
        denNgayKHTT: moment(this.state.denNgayKHTT, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
        tuNgayCuocThanhTra: moment(this.state.tuNgayTTDX, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
        denNgayCuocThanhTra: moment(this.state.denNgayTTDX, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
        choPhepChinhSuaKeHoachTuNgay: moment(this.state.choPhepChinhSuaKeHoachTuNgay, 'DD/MM/YYYY').add(7, 'hours').toISOString(),
      };
      ThanhTra.actions.patchCauHinhKeHoachThanhTra.request({ id: 1 }, params).then(res => {
        if (!isEmpty(res.data)) {
          Toastr(msg.xldLuu, 'success');
          this.goBack();
        }
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }

  handleChangeDate(name, e) {
    this.setState({
      [name]: e
    });
  }

  onSwitch(e) {
    this.setState({
      switch: e.target.checked
    });
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center cauhinh-khtt">
          <div className="top-content">
            <div className="title">
              <h2>Cấu hình kế hoạch thanh tra</h2>
            </div>
          </div>
          <div className="content">
            <div className="container-chtt">
              <div className="mb10">
                <div className="col-6">
                  <div className="button-switch">
                    <label className="description-chtt">
                      <span>Hiển thị thêm mới KHTT :</span>
                    </label>
                    <label className="switch">
                      <input type="checkbox" checked={this.state.switch} onChange={this.onSwitch.bind(this)} />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="title-chtt">
                <span >
                  Kế hoạch thanh tra :
                </span>
              </div>
              <div className="wrap-input-chtt">
                <DatePicker
                  require
                  bindValidator={this}
                  className="col-input col-25"
                  label="Từ ngày"
                  channel="formTaoDon"
                  name="tuNgayKHTT"
                  dateFormat="DD/MM/YYYY"
                  value={this.state.tuNgayKHTT}
                  onChange={this.handleChangeDate.bind(this, 'tuNgayKHTT')}
                  maxLength={18}
                />
                <span className="hyphen"> - </span>
                <DatePicker
                  require
                  bindValidator={this}
                  channel="formTaoDon"
                  className="col-input col-25"
                  label="Đến ngày"
                  name="denNgayKHTT"
                  dateFormat="DD/MM/YYYY"
                  value={this.state.denNgayKHTT}
                  onChange={this.handleChangeDate.bind(this, 'denNgayKHTT')}
                  maxLength={18}
                />
              </div>
              <div className="title-chtt">
                <span>
                  Cuộc thanh tra đột xuất:
                </span>
              </div>
              <div className="wrap-input-chtt">
                <DatePicker
                  require
                  bindValidator={this}
                  className="col-input col-25"
                  label="Từ ngày"
                  channel="formTaoDon"
                  name="tuNgayTTDX"
                  dateFormat="DD/MM/YYYY"
                  value={this.state.tuNgayTTDX}
                  onChange={this.handleChangeDate.bind(this, 'tuNgayTTDX')}
                  maxLength={18}
                />
                <span className="hyphen"> - </span>
                <DatePicker
                  require
                  bindValidator={this}
                  className="col-input col-25"
                  label="Đến ngày"
                  channel="formTaoDon"
                  name="denNgayTTDX"
                  dateFormat="DD/MM/YYYY"
                  value={this.state.denNgayTTDX}
                  onChange={this.handleChangeDate.bind(this, 'denNgayTTDX')}
                  maxLength={18}
                />
              </div>
              <div className="title-chtt">
                <span>
                  Ngày chỉnh sửa kế hoạch thanh tra:
                </span>
              </div>
              <div className="wrap-input-chtt">
                <DatePicker
                  require
                  bindValidator={this}
                  className="col-input col-25"
                  label="Ngày chỉnh sửa"
                  channel="formTaoDon"
                  name="choPhepChinhSuaKeHoachTuNgay"
                  dateFormat="DD/MM/YYYY"
                  value={this.state.choPhepChinhSuaKeHoachTuNgay}
                  onChange={this.handleChangeDate.bind(this, 'choPhepChinhSuaKeHoachTuNgay')}
                  maxLength={18}
                />
              </div>
              <div className="button-group mt10">
                <Link onClick={this.goBack.bind(this)} className="btn-action btn-close" >
                  <span>Đóng</span>
                </Link>
                <Link className="btn-action btn-save" onClick={this.saveCauHinhThanhTra.bind(this)} >
                  <span>Lưu</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    )
  }
}

CauHinhKHTT.defaultProps = {
  validators: {},
}

export default CauHinhKHTT



// WEBPACK FOOTER //
// ./src/components/modules/category/CauHinhKHTT.jsx